import {Toast } from 'mint-ui';
export default {
    data() {
        return {
            sessionKey: '',
            satisfaction: {
                list: [],
                labels: [],
                content: ''
            },
            satisfactionDisabled: false,
            result: null,
            resultMsg: '',
            second: 5,
            timer: null
        }
    },
    mounted() {
        if (this.$route.query) {
            this.sessionKey = this.$route.query.sessionKey ? this.$route.query.sessionKey : '';
        }
        if (this.sessionKey) {
            this.getConfig();
        }
    },
    methods: {
        /**
         * 获取满意度配置信息
         */
        async getConfig() {
            let res = await this.$http.get('/satisfaction/' + this.sessionKey + '/config');
            this.result = res.ret;
            if(res.data && res.ret == 0) {
                this.satisfaction = {
                    ...this.satisfaction,
                    ...res.data
                };
                let list = this.getStarInfo(res.data);
                this.satisfaction.list = list;
            }else{
                this.resultMsg = res.msg;
                const that = this;
                that.second = 5;
                that.timer = setInterval(function(){
                    if (that.second == 0) {
                        clearInterval(that.timer);
                        that.timer = null;
                        that.closeWindow();
                    }else{
                        that.second--;
                    }
                }, 1000)
            }
        },
        /**
         * 获取满意度列表
         * */
        getStarInfo(item){
            let list = [];
            if (item.config) {
                for (var i = 1; i <= 5; i++) {
                    if (i == 1) {
                        list.push({
                            key: i,
                            labels: item.config['one'].labels,
                            remark: item.config['one'].remark
                        })
                    }else if (i == 2) {
                        list.push({
                            key: i,
                            labels: item.config['two'].labels,
                            remark: item.config['two'].remark
                        })
                    }else if (i == 3) {
                        list.push({
                            key: i,
                            labels: item.config['three'].labels,
                            remark: item.config['three'].remark
                        })
                    }else if (i == 4) {
                        list.push({
                            key: i,
                            labels: item.config['four'].labels,
                            remark: item.config['four'].remark
                        })
                    }else if (i == 5) {
                        list.push({
                            key: i,
                            labels: item.config['five'].labels,
                            remark: item.config['five'].remark
                        });
                    }
                }
            }
            return list;
        },
        /**
         * 评价
         * @param { Object } item 
         * @param { Number } index     索引值
         */
        giveStar(item,index) {
            this.$set(item,"defaultStar", index);
            this.$set(item,"labels", []);
        },  
        /**
         * 满意度标签
         * */
        selectLabel(item,tag){
            if (item.labels.indexOf(tag) > -1) {
                item.labels.splice(item.labels.indexOf(tag), 1);
            }else{
                if (item.maxLabelCount == item.labels.length) {
                    this.satisfactionDisabled = true;
                    let that = this;
                    setTimeout(function(){
                        that.satisfactionDisabled = false;
                    }, 4000)
                    return;
                }
                item.labels.push(tag);
            }
        },
        /**
         * 获取满意度配置信息
         */
        async submit() {
            if (this.satisfaction.defaultStar == 0) {
                return;
            }
            let res = await this.$http.post('/satisfaction', {
                sessionKey: this.sessionKey,
                level: this.satisfaction.defaultStar,
                content: this.satisfaction.content || '',
                labels: this.satisfaction.labels || []
            });
            if(res.ret == 0) {
                this.result = 8888;
                this.resultMsg = '评价成功';
                const that = this;
                that.second = 5;
                that.timer = setInterval(function(){
                    if (that.second == 0) {
                        clearInterval(that.timer);
                        that.timer = null;
                        that.closeWindow();
                    }else{
                        that.second--;
                    }
                }, 1000)
            }else{
                Toast(res.msg);
            }
        },
        closeWindow() {
            WeixinJSBridge.call('closeWindow');
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/satisfaction/_satisfaction.js